<template>
    <div class="section_ticker">
        <!-- <img
            src="@/assets/background/Line_6.svg"
            class="line_6"
        />
        <img
            src="@/assets/background/Line_6_mob.svg"
            class="line_6_mob"
        /> -->
        <!-- <img
            src="@/assets/background/Triangles_6.png"
            class="Triangles_6"
        />
        <img
            src="@/assets/background/Triangles_6_mob.png"
            class="Triangles_6_mob"
        /> -->
        <h3 class="characteristics_title text_align_center">Партнеры</h3>
        <div class="box_TickerAbout">
            <MarqueeRow
                v-for="(row, index) in rows"
                :key="index"
                :ids="row.ids"
                :reverse="row.reverse"
            />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import MarqueeRow from './MarqueeRow.vue';
import big_1 from '@/assets/slider/big_1.jpg';
import big_3 from '@/assets/slider/big_3.jpg';
import big_4 from '@/assets/slider/big_4.jpg';
import big_5 from '@/assets/slider/big_5.jpg';
import big_6 from '@/assets/slider/big_6.jpg';
import big_7 from '@/assets/slider/big_7.jpg';
import big_8 from '@/assets/slider/big_8.jpg';
import big_9 from '@/assets/slider/big_9.jpg';
import big_10 from '@/assets/slider/big_10.jpg';

import long_1 from '@/assets/slider/long_1.jpg';
import long_2 from '@/assets/slider/long_2.jpg';
import long_3 from '@/assets/slider/long_3.jpg';
import long_4 from '@/assets/slider/long_4.jpg';
import long_5 from '@/assets/slider/long_5.jpg';
import long_6 from '@/assets/slider/long_6.jpg';
import long_7 from '@/assets/slider/long_7.jpg';
import long_8 from '@/assets/slider/long_8.jpg';
import long_9 from '@/assets/slider/long_9.jpg';
import long_10 from '@/assets/slider/long_10.jpg';
import long_11 from '@/assets/slider/long_11.jpg';
import long_12 from '@/assets/slider/long_12.jpg';
import long_13 from '@/assets/slider/long_13.jpg';
import long_14 from '@/assets/slider/long_14.jpg';
import long_15 from '@/assets/slider/long_15.jpg';
import long_16 from '@/assets/slider/long_16.jpg';
import long_17 from '@/assets/slider/long_17.jpg';
import long_18 from '@/assets/slider/long_18.jpg';
import long_19 from '@/assets/slider/long_19.jpg';
import long_20 from '@/assets/slider/long_20.jpg';
import long_21 from '@/assets/slider/long_21.jpg';
import long_22 from '@/assets/slider/long_22.jpg';
import long_23 from '@/assets/slider/long_23.jpg';
import long_24 from '@/assets/slider/long_24.jpg';
import long_25 from '@/assets/slider/long_25.jpg';

export default defineComponent({
    name: 'TickerAbout',
    components: { MarqueeRow },
    data () {
        return {
            rows: [
                {
                    ids: [
                        long_1,
                        long_2,
                        long_3,
                        long_4,
                        long_5,
                        long_6,
                        long_7,
                        long_8,
                        long_9,
                        long_10,
                        long_11,
                        long_12,
                        long_13,

                    ],
                    reverse: true,
                },
                {
                    ids: [
                        big_1,
                        big_3,
                        big_4,
                        big_5,
                        big_6,
                        big_7,
                        big_1,
                        big_3,
                        big_4,
                        big_5,
                        big_6,
                        big_7,
                        big_8,
                        big_9,
                        big_10,
                    ],
                    reverse: false,
                },
                {
                    ids: [
                        long_14,
                        long_15,
                        long_16,
                        long_17,
                        long_18,
                        long_19,
                        long_20,
                        long_21,
                        long_22,
                        long_23,
                        long_24,
                        long_25,

                    ],
                    reverse: true,
                },
            ],
        };
    },
});
</script>

<style>
.wrap {
    max-width: 100%;
    margin: auto;
    padding: 96px 0px 53px 0px;
}

.items-wrap {
    position: relative;
    display: flex;
    overflow: hidden;
    user-select: none;
    gap: 1rem;
}

.items-wrap:before,
.items-wrap:after {
    /* content: ""; */
    height: 100%;
    top: 0;
    width: 10%;
    position: absolute;
    z-index: 1;
    pointer-events: none;
}

.items-wrap:before {
    left: 0;
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
    );
}

.items-wrap:after {
    right: 0;
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
    );
}

.items {
    flex-shrink: 0;
    display: flex;
    gap: 1.5rem;
    counter-reset: item;
    justify-content: space-around;
    min-width: 100%;
}

.item {
    flex: 0 0 auto;
    width: auto;
    height: auto;
    counter-increment: item;
    border-radius: 0.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    transition: all 0.1s ease-in-out;
    font-family: Rostov;
    font-size: 4.8rem;
    font-weight: 400;
    line-height: 4.8rem;
    letter-spacing: 2%;
    text-align: left;
    text-transform: uppercase;
    color: rgb(245, 245, 245);
    -webkit-text-stroke: 1px black;
    /* Ширина и цвет бордера вокруг текста для браузеров на основе WebKit */
    transition: 0.3s ease;
}

.item:hover {
    color: rgb(25, 25, 25);
}

.marquee {
    animation: scroll 20s linear infinite;
}

.reverce {
    animation-direction: reverse;
}
.Triangles_6 {
    width: 26.35rem;
    height: 59.9rem;
    position: absolute;
    z-index: -1;
    left: 0px;
    top: -12rem;
}
.box_TickerAbout{
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

@media (max-width: 991px) {
    .item {
        font-size: 4rem;
        font-weight: 400;
        line-height: 4rem;
    }
}

.marquee:hover {
    animation-play-state: paused;
    /* Останавливаем анимацию при наведении */
}
.Triangles_6_mob {
    display: none;
}
@media (max-width: 767px) {
    .Triangles_6 {
        display: none;
    }
    .Triangles_6_mob {
        display: block;
        position: absolute;
        width: 23.13rem;
        height: 53rem;
        z-index: -1;
        top: -10.375rem;
    }
}
</style>
